import styles from "../landing-page-four.module.css";

interface ExamplesSectionProps {
  onClickExample: () => void;
}

export const ExamplesSection = (props: ExamplesSectionProps) => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.exampleImagesContainer}>
        <img
          className={styles.exampleImage}
          src="/landing-page/landing-four/example-1.webp"
          alt="Example 1"
          loading="lazy"
          width={300}
          height={400}
          onClick={props.onClickExample}
        />
        <img
          className={styles.exampleImage}
          src="/landing-page/landing-four/example-2.webp"
          alt="Example 2"
          loading="lazy"
          width={300}
          height={400}
          onClick={props.onClickExample}
        />
        <img
          className={styles.exampleImage}
          src="/landing-page/landing-four/example-3.webp"
          alt="Example 3"
          loading="lazy"
          width={300}
          height={400}
          onClick={props.onClickExample}
        />
        <img
          className={styles.exampleImage}
          src="/landing-page/landing-four/example-4.webp"
          alt="Example 4"
          loading="lazy"
          width={300}
          height={400}
          onClick={props.onClickExample}
        />
      </div>
    </div>
  );
};
